module.exports = __webpack_public_path__ + "img/HNYT087_21.763fe06d.gif";